import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import previousIconUrl from '../ActionButtons/assets/button-previous.svg';
import nextIconUrl from '../ActionButtons/assets/button-next.svg';
import { Mixpanel } from 'helpers/Mixpanel';
import S from './styled'; // styled components

class ImageWin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      enlarged: false,
      parent: '',
      localCurrentIdx: props.currentIdx || -1,
      hovered: [],
      hoveredBigImg: false,
    };
  }

  componentDidMount() {
    const { replacedElement, currentIdx } = this.props;
    this.setState({
      parent: replacedElement,
      localCurrentIdx: currentIdx,
      hovered: this.getUpdatedHovered(currentIdx),
    });

    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowLeft':
        this.handlePrevious(e);
        break;
      case 'ArrowRight':
        this.handleNext(e);
        break;
      case 'Escape':
        this.handleClose(e);
        break;
      default:
        break;
    }
  };

  getUpdatedHovered = (index) => {
    const { allPictures } = this.props;
    return Array(allPictures.length).fill(false).map((_, i) => i === index);
  };

  handleClose = (e) => {
    e.preventDefault();
    this.props.closeWin?.(e);
    Mixpanel.track('Close image detail');
  };

  handlePrevious = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      const newIndex = prevState.localCurrentIdx - 1;
      if (newIndex >= 0) {
        Mixpanel.track('Previous image');
        return {
          localCurrentIdx: newIndex,
          hovered: this.getUpdatedHovered(newIndex),
        };
      }
      return null;
    });
  };

  handleNext = (e) => {
    e.preventDefault();
    const { allPictures } = this.props;
    this.setState((prevState) => {
      const newIndex = prevState.localCurrentIdx + 1;
      if (newIndex < allPictures.length) {
        Mixpanel.track('Next image');
        return {
          localCurrentIdx: newIndex,
          hovered: this.getUpdatedHovered(newIndex),
        };
      }
      return null;
    });
  };

  handlePictureClick = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ enlarged: !prevState.enlarged }));
  };

  handleSmallImageEnter = (index) => {
    this.setState({ hovered: this.getUpdatedHovered(index) });
  };

  handleSmallImageLeave = (index) => {
    this.setState((prevState) => {
      const newHovered = [...prevState.hovered];
      newHovered[index] = false;
      return { hovered: newHovered };
    });
  };

  handleSmallImageClick = (index) => {
    this.setState({
      localCurrentIdx: index,
      hovered: this.getUpdatedHovered(index),
    });
  };

  handleBigImageHover = (hovering) => {
    this.setState({ hoveredBigImg: hovering });
  };

  render() {
    const { allPictures, isChat } = this.props;
    const { localCurrentIdx, hovered, hoveredBigImg } = this.state;

    if (localCurrentIdx < 0 || localCurrentIdx >= allPictures.length) return null;

    const currentPic = allPictures[localCurrentIdx];

    return (
      <S.Container onClick={this.handleClose}>
        <S.CloseButton onClick={this.handleClose}>×</S.CloseButton>

        <S.ImageViewer onClick={(e) => e.stopPropagation()}>
          {localCurrentIdx > 0 && (
            <S.NavButton direction="left" onClick={this.handlePrevious}>
              <img src={previousIconUrl} style={{ width: 48, height: 48 }} />
            </S.NavButton>
          )}

          <S.BigImage
            src={isChat ? currentPic : currentPic.full_url}
            onClick={this.handlePictureClick}
            onMouseEnter={() => this.handleBigImageHover(true)}
            onMouseLeave={() => this.handleBigImageHover(false)}
            alt="Preview"
          />

          {localCurrentIdx < allPictures.length - 1 && (
            <S.NavButton direction="right" onClick={this.handleNext}>
              <img src={nextIconUrl} style={{ width: 48, height: 48 }} />
            </S.NavButton>
          )}

          <S.ThumbnailBar onClick={(e) => e.stopPropagation()}>
            {allPictures.map((pic, idx) => (
              <S.Thumbnail
                key={idx}
                src={isChat ? pic : pic.thumb_url}
                hovered={hovered[idx]}
                onMouseEnter={() => this.handleSmallImageEnter(idx)}
                onMouseLeave={() => this.handleSmallImageLeave(idx)}
                onClick={() => this.handleSmallImageClick(idx)}
              />
            ))}
          </S.ThumbnailBar>
        </S.ImageViewer>
      </S.Container>
    );
  }
}

ImageWin.propTypes = {
  closeWin: PropTypes.func.isRequired,
  allPictures: PropTypes.array.isRequired,
  currentIdx: PropTypes.number,
  replacedElement: PropTypes.any,
};

ImageWin.defaultProps = {
  currentIdx: -1,
};

export default injectIntl(ImageWin);
